module.exports = "/assets/f86ca4c5522ab0efbc849ef7dc941a88.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/TX.png
// module id = 2992
// module chunks = 0